import { ArrowLeft, Phone } from "lucide-react";

export const SubpageShell = ({ children, onQuote }) => (
    <div className="min-h-screen bg-[#0A0D14] font-sans text-slate-50">
        <div className="grain-overlay" aria-hidden="true" />
        <header
            data-testid="subpage-header"
            className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[#0A0D14]/85 backdrop-blur-xl"
        >
            <div className="mx-auto flex h-[72px] max-w-5xl items-center justify-between px-4 sm:px-6">
                <a href="/" data-testid="subpage-home-link" className="flex items-center gap-3">
                    <img
                        src="/logo-horizontal.png"
                        alt="AdvantaShield Warranty"
                        className="h-10 w-auto"
                    />
                </a>
                <div className="flex items-center gap-3">
                    <a
                        href="/"
                        className="hidden items-center gap-2 text-sm font-medium text-slate-300 transition-colors hover:text-white sm:inline-flex"
                    >
                        <ArrowLeft className="h-4 w-4" /> Back to home
                    </a>
                    <button
                        data-testid="subpage-quote-btn"
                        onClick={onQuote}
                        className="rounded-full bg-sky-400 px-5 py-2.5 text-sm font-bold text-[#0A0D14] transition-[background-color,box-shadow] duration-300 hover:bg-sky-300 hover:shadow-[0_0_28px_rgba(56,189,248,0.45)]"
                    >
                        Get a Quote
                    </button>
                </div>
            </div>
        </header>
        <main className="mx-auto max-w-5xl px-4 pb-24 pt-32 sm:px-6 md:pt-36">
            {children}
        </main>
        <footer className="border-t border-white/10">
            <div className="mx-auto flex max-w-5xl flex-col items-start justify-between gap-3 px-4 py-8 text-xs text-slate-600 sm:flex-row sm:items-center sm:px-6">
                <p>© 2026 AdvantaShield. All rights reserved.</p>
                <a
                    href="tel:+18886874889"
                    data-testid="subpage-phone-link"
                    className="inline-flex items-center gap-2 font-semibold text-slate-400 transition-colors hover:text-sky-300"
                >
                    <Phone className="h-3.5 w-3.5 text-sky-400" />
                    (888) 687-4889
                </a>
                <p className="font-mono text-[11px] uppercase tracking-[0.25em]">
                    Created by dealers, for dealers
                </p>
            </div>
        </footer>
    </div>
);
